<template>
    <button
        class="video_call_request"
        :class="{ call_actv: active }"
        :disabled="isDisabled"
        @click="handleClick"
    >
        <span class="call_txt">
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 452 452">
                <g>
                    <path
                        d="m452 25.121094v227.820312l-121.878906-66.550781h-1.210938v-94.71875h1.210938zm0 0"
                        :fill="computedIconColor"
                    />
                    <path
                        d="m328.910156 186.390625v51.03125c0 22.089844-17.910156 40-40 40h-248.910156c-22.089844 0-40-17.910156-40-40v-197.421875c0-22.089844 17.910156-40 40-40h248.910156c22.089844 0 40 17.910156 40 40zm0 0"
                        :fill="computedIconColor"
                    />
                </g>
            </svg>
        </span>

        <span
            v-if="computedShowCallingText"
            class="calling_txt"
        >
            Calling
        </span>
    </button>
</template>

<script>
export default {
    name: "VideoCallButton",

    props: {
        isOnline: {
            type: Boolean,
            default: false
        },

        browserOnline: {
            type: Boolean,
            default: false
        },

        active: {
            type: Boolean,
            default: false
        },

        isCalling: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        canCall() {
            return this.isOnline && this.browserOnline;
        },

        isDisabled() {
            return !this.canCall || (this.isCalling && !this.active);
        },

        computedIconColor() {
            return this.canCall ? "#0aefea" : "#4a6b6b";
        },

        computedShowCallingText() {
            return this.canCall;
        }
    },

    methods: {
        handleClick() {
            if (!this.isDisabled) {
                this.$emit("call");
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.video_call_request {
  font-size: 16px;
  background-color: rgba(31, 31, 31, 0.5);
  border: 1px solid rgba(174, 182, 184, 0.1);
  color: #fff;
  position: absolute;
  right: 5px;
  top: 50%;
  border-radius: 3px;
  padding: 5px;
  letter-spacing: 0px;
  line-height: 1;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color emoji;
  min-width: 36px;
  height: 34px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  overflow: hidden;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.4;
  }

  .calling_txt {
    display: none;
  }

  &.call_actv {
    background: #87cefa !important;
    color: #000 !important;

    svg path,
    svg path {
      fill: #000000;
    }
  }

  &.call_actv {
    .calling_txt {
      display: inline-block;
    }
  }

  &.call_actv {
    .call_txt {
      display: none;
    }
  }

  &::before {
    content: "";
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(120deg,
        transparent,
        rgba(255, 255, 255, 0.2),
        transparent);
    left: -100%;
    transition: all 0.65s ease-in-out;
  }

  &:hover {
    box-shadow: 1px 1px 25px 10px rgba(255, 255, 255, 0.5) !important;

    &::before {
      left: 100%;
    }
  }
}
</style>